import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import API from "../api";
import usePageMeta from "../hooks/usePageMeta";
import { setToken } from "../utils/auth";

export default function DirectLogin() {
  usePageMeta("Direct Login");
  const { guid } = useParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await API.get(`/auth/direct-login/${encodeURIComponent(guid || "")}`);
        const token = res?.data?.token;
        const user = res?.data?.user || {};

        if (!mounted) return;
        if (!token || !user?.account_id) {
          setErrorMessage("Invalid direct login response.");
          return;
        }

        const userType = String(user.type || "").toLowerCase();
        const registrationComplete =
          user.registration === "1" ||
          user.registration === 1 ||
          user.registration_complete;

        setToken(token);
        localStorage.setItem("accountId", String(user.account_id));
        localStorage.setItem("userType", userType);
        localStorage.setItem("isAdmin", userType === "admin" ? "true" : "false");
        localStorage.setItem(
          "registrationComplete",
          registrationComplete ? "true" : "false",
        );
        if (user.client_id) localStorage.setItem("clientId", String(user.client_id));
        else localStorage.removeItem("clientId");
        window.dispatchEvent(new Event("authUpdate"));

        if (
          userType === "fieldstaff" ||
          userType === "outsourcestaff" ||
          userType === "outsourcedstaff"
        ) {
          navigate("/availability", { replace: true });
          return;
        }
        if (user.client_id && userType !== "fieldstaff" && userType !== "outsourcestaff") {
          navigate("/client-dashboard", { replace: true });
          return;
        }
        navigate("/dashboard", { replace: true });
      } catch (err) {
        if (!mounted) return;
        setErrorMessage(
          err?.response?.data?.message || "Direct login link is invalid or unavailable.",
        );
      }
    })();

    return () => {
      mounted = false;
    };
  }, [guid, navigate]);

  return (
    <div className="auth-container">
      <div className="background-overlay"></div>
      <div className="form-container">
        <div className="form-card">
          <h1 className="form-title">Direct Login</h1>
          {!errorMessage && <p>Signing you in...</p>}
          {errorMessage && (
            <div>
              <p className="error-text">{errorMessage}</p>
              <p className="form-footer">
                Go to <Link className="toggle-form" to="/login">Sign In</Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
